import {
  EXPERTS_LAUNCH_SEGMENT,
  LIKE_LISTINGS_SEGMENT,
  LUXURY_SEGMENT,
  TOWNHOUSE_SEGMENT,
  VERTICAL_LIVING_SEGMENT
} from "src/shared/experts/constants/segments";
import { switchSegmentName } from "src/shared/experts/utilities/segments";

import useFeatureState from "./hooks/useFeatureState";

export const switchWithSegmentName = returnValues => {
  const { segmentName } = useFeatureState();

  return switchSegmentName(segmentName, returnValues);
};

export const getHeaderText = () =>
  switchWithSegmentName({
    [EXPERTS_LAUNCH_SEGMENT]: "Recent Deals",
    [LIKE_LISTINGS_SEGMENT]: "Recent Deals",
    [LUXURY_SEGMENT]: "Recent Deals",
    [TOWNHOUSE_SEGMENT]: "Experience in Townhouses",
    [VERTICAL_LIVING_SEGMENT]: "Experience in this Building"
  });

export const getTooltipText = () =>
  switchWithSegmentName({
    [EXPERTS_LAUNCH_SEGMENT]:
      "This agent has verified experience in listings like this one.",
    [LIKE_LISTINGS_SEGMENT]:
      "This agent has verified experience in listings like this one.",
    [LUXURY_SEGMENT]:
      "This agent has verified experience in listings like this one.",
    [TOWNHOUSE_SEGMENT]:
      "This agent has verified experience in townhouses near this listing.",
    [VERTICAL_LIVING_SEGMENT]:
      "This agent has verified experience in this building."
  });
